import { render, staticRenderFns } from "./AccessoryCard.vue?vue&type=template&id=13dfa032&scoped=true&"
import script from "./AccessoryCard.vue?vue&type=script&lang=ts&"
export * from "./AccessoryCard.vue?vue&type=script&lang=ts&"
import style0 from "./AccessoryCard.vue?vue&type=style&index=0&id=13dfa032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dfa032",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
